export const MENU_LIST = "/menu/mylist";
